import { ReactSVG } from 'react-svg'

import { SOCIAL } from '@shared/contants/social'

import styles from './styles.module.scss'

export default function SocialList () {
  return (
    <div className={styles.root}>
      {SOCIAL.map((item, index) => {
        return (
          <a
            className={styles.root__item}
            href={item.url}
            target="_blank"
            key={index}
          >
            <ReactSVG src={item.icon} wrapper="span" />
          </a>
        )
      })}
    </div>
  )
}
